<h1 mat-dialog-title>Konieczna weryfikacja dostawcy</h1>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutGap="16px">
    <div>
      Płatność kartą niedostępna<span *ngIf="customerBillersInfo.billers as billers">
        dla dostawców: {{ billers }}.</span
      >
    </div>

    <div>
      Aby zweryfikować dostawcę, wystarczy skontaktować się z obsługą klienta na czacie. Kliknij
      <span class="link" matDialogClose (click)="openChatWithPreparedMessage()">zweryfikuj</span>
      i wypełnij szablon wiadomości.
    </div>

    <div>
      Dowiedz się więcej klikając
      <a
        href="https://payappka.document360.io/docs/odblokowanie-p%C5%82atnosci-karta-przez-weryfikacje-dostawcy"
        target="_blank"
        >tutaj</a
      >.
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button mat-raised-button matDialogClose color="primary" (click)="openChatWithPreparedMessage()">
    Zweryfikuj
  </button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
